import { useState } from 'react'
import { Image, Video, CourseMediaWrapper } from './styles'

export const CourseMedia = ({ imageSrc, videoUrl }: { imageSrc: string; videoUrl?: string }) => {
  const [hovered, setHovered] = useState(false)
  let media = <Image src={imageSrc} alt="Preview" />

  if (hovered && videoUrl) {
    const playerUrl = new URL(videoUrl)
    playerUrl.searchParams.set('muted', '1')

    media = <Video src={playerUrl?.toString()} allow="autoplay; fullscreen" allowFullScreen />
  }

  return (
    <CourseMediaWrapper
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {media}
    </CourseMediaWrapper>
  )
}
